import { Injectable, Injector } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'vnpost-shared';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SaleRecordService extends BaseService {
  constructor(http: HttpClient, injector: Injector) {
    super(
      http,
      injector,
      `${environment.apiDomain.llbJavaEndpoint}/saleRecords`
    );
  }
  getAll(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/getAll`;
    return this._http.post<any>(apiUrl, model).toPromise();
  }
  create(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/create`;
    return this._http
      .post<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  update(code: any, model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/update/${code}`;
    return this._http
      .put<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  delete(code: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/delete/${code}`;
    return this._http
      .delete<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  getRevenue(model: any) {
    const apiUrl = `${this.serviceUri}/getSales`;
    return this._http
      .post<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  getSaleRecord(code: any) {
    const apiUrl = `${this.serviceUri}/getSaleRecords/${code}`;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  random() {
    const apiUrl = `${this.serviceUri}/random`;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }

  importFile(file: FormData): Promise<any> {
    const apiUrl = `${this.serviceUri}/batchCreate`;
    return this._http
      .post<any>(apiUrl, file)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
}
